export type GasSafetyAnswer = 'YES' | 'NO';

export interface GasEmergencyReasonOption {
  value: string;
  label: string;
}

export interface GasEmergencyContact {
  area: string;
  displayNumber: string;
  href: string;
}

export const GAS_SAFETY_ANSWERS: GasSafetyAnswer[] = ['YES', 'NO'];

export const GAS_EMERGENCY_REASONS: GasEmergencyReasonOption[] = [
  {
    value: 'gas-smell-after-repair',
    label: 'Gas smell after a Domestic & General repair',
  },
  { value: 'gas-leak', label: 'Gas leak' },
  { value: 'carbon-monoxide', label: 'Carbon monoxide' },
];

export const GAS_EMERGENCY_CONTACTS: GasEmergencyContact[] = [
  {
    area: 'Northern Ireland',
    displayNumber: '0800 002 001',
    href: 'tel:0800002001',
  },
  {
    area: 'England, Wales and Scotland',
    displayNumber: '0800 111 999',
    href: 'tel:0800111999',
  },
  {
    area: 'Isle of Man',
    displayNumber: '0808 1624 444',
    href: 'tel:08081624444',
  },
];

export const MOBILE_DEVICE_REGEX =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
